import { useMemo } from 'react';

import { DataTable, type TableColumn } from '@/src/ui';
import type { ExamAssignmentDTO } from '../StudentDashboardDTOs';
import { ReportHeaderStyle, ReportCellStyle, utcToLocal, formatOptions } from '@/src/utils';

interface ExamAssignmentsTableProps {
    data: Array<ExamAssignmentDTO>;
}

export default function ExamAssignmentsTable(props: ExamAssignmentsTableProps) {
    const { data } = props;

    const columns = useMemo<TableColumn[]>(() => {
        return [
            {
                dataKey: 'title',
                header: 'Assessment',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
            },
            {
                dataKey: 'toDate',
                header: 'Available Until',
                align: 'left',
                width: 100,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
                formatter: (row) => {
                    return row.toDate
                        ? utcToLocal(row.toDate)?.toLocaleString(undefined, formatOptions)
                        : '--';
                },
            },
        ];
    }, []);

    return (
        <>
            <DataTable
                data={data}
                columns={columns}
                tableName="Assessments"
                alternatingRowColor
                rowsPerPageInitial={10}
                rowsPerPageList={[10]}
                defaultSortColumn="examName"
                defaultSortDirection="asc"
            />
        </>
    );
}
